import React, {useRef} from 'react';
import {withStyles} from '@mui/styles';
import {Slide} from "@mui/material";

const styles = {
  question:{
    minHeight: "calc( 24px * 4 )",
    border: "1px solid rgba(0,0,0,0.12)",
    borderRadius: "4px",
    padding: "0.25rem",
    backgroundColor: "#fafafa",
  },
  subtitle: {
    fontSize: "calc(0.7225em * 0.85)",
    fontWeight: "500",
    color: "rgba(0,0,0,0.5)",
    borderBottom: "1px solid rgba(0,0,0,0.06)",
    textTransform: "uppercase",
  },
  statement:{
    fontSize: '1.15em',
    fontWeight: '500',
    minHeight: "4.8em",
    display: "flex",
    alignItems: "center",
    padding: "0.25rem",
    justifyContent: "center",
  },
}

function QuestionDisplay(props) {
  const { subtitle, statement, slide=true, classes } = props;
  const containerRef = useRef(null);

  return (
    <div className={classes.question} ref={containerRef}>
      <div>
        {!subtitle ? null : <div className={classes.subtitle}>{subtitle}</div>}
        <Slide in={slide} direction={slide ? "right" : "left"} container={containerRef.current} hidden={!slide}>
          <div id={"questionStatement"} className={classes.statement}>{statement}</div>
        </Slide>
      </div>
    </div>
  )
}

export default withStyles(styles)(QuestionDisplay);